import { useLocation } from 'react-router';
import { OrganizacnaSkupinaEnum } from 'ciselniky-frontend-ts-axios';
import useOrganizacie from '../../../hooks/useOrganizacie';
import Uuid from '../../../model/types/Uuid';
import PrispevokVestnikaListFilter from '../../../model/PrispevokVestnikaListFilter';
import stringToDate from '../../../function/stringToDate';

// eslint-disable-next-line prefer-regex-literals
const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-f]{12}$/i;

const mapSearchText = (searchText: string): string => {
  if (searchText && searchText.trim().length > 0) {
    return decodeURIComponent(searchText.trim().replace(/^"(.*)"$/, '$1'));
  }
  return '';
};

const getOrganizaciaUuid = (uuid: string): Uuid => {
  if (uuid && uuid.match(uuidRegex)) {
    return uuid;
  }
  return null;
};

interface ReturnType {
  initialFilterLoading: boolean;
  initialFilter: PrispevokVestnikaListFilter;
}

export default (): ReturnType => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);

  const organizaciaUuid = getOrganizaciaUuid(search.get('vestnikUuid'));

  const {
    organizacie,
    organizacieStatus,
  } = useOrganizacie(
    OrganizacnaSkupinaEnum.Vestnik,
    undefined,
    undefined,
    [organizaciaUuid],
    organizaciaUuid !== null,
  );

  return {
    initialFilter: organizacie ? {
      datumZverejneniaOd: stringToDate(search.get('datumZverejneniaOd')),
      datumZverejneniaDo: stringToDate(search.get('datumZverejneniaDo')),
      datumUcinnostiOd: stringToDate(search.get('datumUcinnostiOd')),
      datumUcinnostiDo: stringToDate(search.get('datumUcinnostiDo')),
      searchTextVyraz: mapSearchText(search.get('hladanyVyraz')),
      searchTextCislo: mapSearchText(search.get('cislo')),
      searchTextNazov: mapSearchText(search.get('nazov')),
      searchTextRocnik: mapSearchText(search.get('datumZverejneniaRok')),
      rezort: organizacie?.length > 0 ? organizacie[0] : null,
    } : null,
    initialFilterLoading: organizacieStatus.loading,
  };
};
